import { DEPLOY_ENV } from '../components/globals';

export const HOMEPAGE_URL = {
  production: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
  development: 'http://localhost:3011/homepage-2019',
  localdev: process.env.LOCAL_HOMEPAGE_URL || 'http://localhost:3011/homepage-2019',
  test: 'https://www.opendoor.com',
}[DEPLOY_ENV];

// Public token; meant to be exposed client-side.
// URL restrictions are configured in the Mapbox admin panel.
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tbndmMnpoMDgwNzJzb3Jtdm5wejJpMiJ9.9hm2Ma2vzjbr5Tr4nt4hmA';
export const MAPBOX_MAP_STYLE = 'mapbox://styles/mapbox/standard';
export const MAPBOX_MAP_CONFIG = {
  basemap: {
    lightPreset: 'day',
    show3dObjects: false,
    showPointOfInterestLabels: true,
    showTransitLabels: false,
    theme: 'default',
  },
} as const;

const getIsIOS = () => {
  const userAgent = typeof navigator !== 'undefined' && (navigator.userAgent || navigator.vendor);
  return userAgent && /iPad|iPhone|iPod/.test(userAgent);
};

const platform = getIsIOS() ? 'ios' : 'android';

export const OD_APP_URL = {
  ios: 'https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8',
  android: 'https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en',
}[platform];
